/* LMM PDP — Alternativ-/Ersatzartikel-Modul: Tabs, Drawer, Filter.
   Vanilla, delegierte document-Listener (ueberlebt DOM-Swaps), Init-Guard.

   Mehrinstanz-faehig (27.07.2026): Auf einer PDP koennen zwei Instanzen DERSELBEN
   Komponente liegen — die normalen Alternativen (data-lmm-alt-drawer="") und die
   Nachfolgeprodukte (data-lmm-alt-drawer="succ"). Der Oeffner nennt seinen Scope im
   Wert von data-lmm-alt-open; ein leerer Wert trifft weiterhin die Alternativen-
   Instanz. Mit nur einer Instanz im DOM ist das Verhalten unveraendert. */
(function () {
  'use strict';
  if (window.__lmmPdpAltInit) return;
  window.__lmmPdpAltInit = true;

  var openerEl = null;
  var activeDrawer = null;

  /* Scope-Aufloesung: data-lmm-alt-open="succ" -> data-lmm-alt-drawer="succ".
     Fallback auf den ersten Drawer nur fuer den scopelosen Altaufruf. */
  function drawerRoot(key) {
    var k = (key || '').replace(/[^A-Za-z0-9_-]/g, '');
    var el = document.querySelector('[data-lmm-alt-drawer="' + k + '"]');
    if (el) return el;
    return k ? null : document.querySelector('[data-lmm-alt-drawer]');
  }

  /* ---------- Panel-Tabs: Gruppen-Container umschalten ---------- */
  function setPanelTab(tabsWrap, key) {
    var panel = tabsWrap.closest('[data-lmm-alt]');
    if (!panel) return;
    tabsWrap.querySelectorAll('[data-lmm-alt-tab]').forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-lmm-alt-tab') === key ? 'true' : 'false');
    });
    panel.querySelectorAll('[data-lmm-alt-group]').forEach(function (g) {
      g.hidden = g.getAttribute('data-lmm-alt-group') !== key;
    });
  }

  /* ---------- Drawer: Tabs + Filter-Chips auf die Item-Liste anwenden ---------- */
  function applyDrawerFilters(root) {
    if (!root) return;
    var activeTabBtn = root.querySelector('.lmm-altdrawer__tools [data-lmm-alt-tab][aria-pressed="true"]');
    var tab = activeTabBtn ? activeTabBtn.getAttribute('data-lmm-alt-tab') : 'all';
    var fBase = root.querySelector('[data-lmm-alt-filter="base"][aria-pressed="true"]') !== null;
    var fStock = root.querySelector('[data-lmm-alt-filter="stock"][aria-pressed="true"]') !== null;
    var filtering = tab !== 'all' || fBase || fStock;
    /* Aufklapp-Zustand haengt am jeweiligen Drawer, nicht global — sonst wuerde die
       eine Instanz den Zustand der anderen mitschalten. */
    var moreExpanded = root.__lmmMoreExpanded === true;
    var visible = 0;

    root.querySelectorAll('[data-lmm-alt-item]').forEach(function (item) {
      var ok = true;
      if (tab !== 'all' && item.getAttribute('data-group') !== tab) ok = false;
      if (fBase && item.getAttribute('data-base-match') !== '1') ok = false;
      if (fStock && item.getAttribute('data-stock') !== '1') ok = false;
      /* Initial-Kappung (>6) nur im ungefilterten Zustand; sobald gefiltert oder
         aufgeklappt wird, zaehlt allein das Filterergebnis. */
      if (ok && !filtering && !moreExpanded && item.hasAttribute('data-lmm-alt-extra')) ok = false;
      item.hidden = !ok;
      if (ok) visible++;
    });

    var empty = root.querySelector('[data-lmm-alt-empty]');
    if (empty) empty.hidden = visible > 0;
    var more = root.querySelector('[data-lmm-alt-more]');
    if (more) more.hidden = filtering || moreExpanded;
    cmpUpdate(root, tab);
  }

  /* ---------- Vergleichstabelle (Chris 02.10.2026) ----------
     Spalte "own" = dieser Artikel. Ein Tab blendet Spalten anderer Gruppen per CSS aus
     (data-tab an der Tabelle). Danach wird ueber die SICHTBAREN Spalten neu bewertet:
     - Zelle weicht vom Ausgangsartikel ab (is-diff) bzw. stimmt ueberein (is-same),
       nur wenn beide Seiten einen Wert haben; fehlende Werte werden nie gewertet.
     - Zeile ohne einen einzigen Wert wird ausgeblendet; bei "Nur Unterschiede" auch
       Zeilen ohne Abweichung (ausser data-keep: Preis, Art.-Nr.).
     - "Vorteile": Bestwert je Kennzahl (data-best min/max) unter den sichtbaren
       Spalten - erst ab zwei Werten und nur, wenn sie sich unterscheiden. Hat genau
       ein Artikel den Bestwert, steht der Superlativ ("hoechster Lichtstrom"); teilen
       ihn mehrere (z. B. 840/865 derselben Serie), bekommen alle die Grundform
       ("hoher Lichtstrom") - zwei "hoechste" wirken unglaubwuerdig (Chris 02.10.2026,
       Runde 5). Der Ausgangsartikel zaehlt nur mit, solange er kaufbar ist (data-buyable).
     - Per X ausgeblendete Spalten (is-rm) zaehlen nirgends mit. Die Leiste wird so
       schmal wie die sichtbaren Spalten, damit die verbliebenen Artikel direkt
       nebeneinander stehen (Chris 02.10.2026). */
  /* [genau ein Bestwert, mehrere gleichauf]. Watt heisst fuer Kunden "Verbrauch". */
  var STR_TXT = {
    price: ['günstigster Preis', 'günstiger Preis'],
    lumen: ['höchster Lichtstrom', 'hoher Lichtstrom'],
    watt: ['niedrigster Verbrauch', 'niedriger Verbrauch'],
    life: ['längste Lebensdauer', 'lange Lebensdauer'],
    eek: ['beste Energieklasse', 'bessere Energieklasse']
  };
  function cmpUpdate(root, tab) {
    var table = root.querySelector('[data-lmm-cmp]');
    if (!table) return;
    table.setAttribute('data-tab', tab || 'all');
    var t = tab || 'all';
    var onlyDiff = root.querySelector('[data-lmm-cmp-diff][aria-pressed="true"]') !== null;
    function vis(cell) {
      if (cell.classList.contains('is-rm')) return false;
      var g = cell.getAttribute('data-g');
      return g === 'own' || t === 'all' || g === t;
    }
    var strengths = {};
    var sameRows = 0;
    var ownHead = table.querySelector('thead [data-g="own"]');
    var ownBuyable = !ownHead || ownHead.getAttribute('data-buyable') !== '0';
    table.querySelectorAll('tbody tr[data-row]').forEach(function (tr) {
      var key = tr.getAttribute('data-row');
      if (key === 'str') return;
      var cells = Array.prototype.slice.call(tr.querySelectorAll('td[data-g]'));
      var own = null;
      cells.forEach(function (c) { if (c.getAttribute('data-g') === 'own') own = c; });
      var ownK = own ? (own.getAttribute('data-k') || '') : '';
      var noDiff = tr.hasAttribute('data-nodiff');
      var anyVal = ownK !== '';
      var anyDiff = false;
      /* Fuer "Nur Unterschiede": unterscheiden sich die sichtbaren Werte ueberhaupt
         (auch untereinander, oder Wert neben fehlender Angabe)? */
      var seen = {};
      var nSeen = 0;
      var anyEmpty = ownK === '';
      if (ownK !== '') { seen[ownK] = 1; nSeen = 1; }
      cells.forEach(function (c) {
        if (c === own) return;
        c.classList.remove('is-diff', 'is-same');
        if (!vis(c)) return;
        var k = c.getAttribute('data-k') || '';
        if (k !== '') {
          anyVal = true;
          if (!seen[k]) { seen[k] = 1; nSeen++; }
        } else {
          anyEmpty = true;
        }
        if (noDiff || k === '' || ownK === '') return;
        if (k !== ownK) { c.classList.add('is-diff'); anyDiff = true; } else { c.classList.add('is-same'); }
      });
      var rowDiffers = nSeen > 1 || (anyEmpty && anyVal);
      var sameRow = anyVal && !rowDiffers && !tr.hasAttribute('data-keep');
      if (sameRow) sameRows++;
      tr.classList.toggle('is-diff', anyDiff);
      tr.hidden = !anyVal || (onlyDiff && sameRow);

      var best = tr.getAttribute('data-best');
      if (!best || !STR_TXT[key]) return;
      var nums = [];
      cells.forEach(function (c) {
        if (!vis(c)) return;
        if (c === own && !ownBuyable) return;
        var n = parseFloat(c.getAttribute('data-n'));
        if (isFinite(n)) nums.push({ c: c, n: n });
      });
      if (nums.length < 2) return;
      var vals = nums.map(function (x) { return x.n; });
      var hi = Math.max.apply(null, vals);
      var lo = Math.min.apply(null, vals);
      if (hi === lo) return;
      var target = best === 'min' ? lo : hi;
      var winners = nums.filter(function (x) { return x.n === target; });
      var txt = STR_TXT[key][winners.length === 1 ? 0 : 1];
      winners.forEach(function (x) {
        var col = x.c.getAttribute('data-col');
        (strengths[col] = strengths[col] || []).push(txt);
      });
    });
    /* Vorteile stehen im feststehenden Kopf (Runde 3) - sonst verschwinden sie beim Scrollen. */
    var strRow = table.querySelector('tr[data-row="str"]');
    if (strRow) {
      var any = false;
      strRow.querySelectorAll('td[data-col]').forEach(function (td) {
        var list = strengths[td.getAttribute('data-col')] || [];
        if (list.length) any = true;
        td.innerHTML = list.length
          ? '<ul class="lmm-cmp__strl">' + list.map(function (s) { return '<li>' + s + '</li>'; }).join('') + '</ul>'
          : '';
      });
      strRow.hidden = !any;
    }

    /* Spalten nach X: das X erscheint nur, solange mindestens zwei Vergleichsartikel
       sichtbar sind; "Alle N" zaehlt die verbliebenen, leer gewordene Reiter verschwinden. */
    var heads = Array.prototype.slice.call(table.querySelectorAll('thead th[data-col]:not([data-g="own"])'));
    var nVis = 0;
    var nKept = 0;
    var groupsLeft = {};
    heads.forEach(function (th) {
      if (th.classList.contains('is-rm')) return;
      nKept++;
      groupsLeft[th.getAttribute('data-g')] = true;
      if (vis(th)) nVis++;
    });
    heads.forEach(function (th) {
      var rm = th.querySelector('[data-lmm-cmp-rm]');
      if (rm) rm.hidden = nVis < 2;
    });
    var cmpPanel = root.querySelector('.lmm-altdrawer__panel--cmp');
    if (cmpPanel) cmpPanel.style.setProperty('--lmm-cmp-cols', String(nVis + 1));
    root.querySelectorAll('.lmm-altdrawer__tools [data-lmm-alt-tab]').forEach(function (b) {
      var k = b.getAttribute('data-lmm-alt-tab');
      if (k === 'all') {
        var tn = b.querySelector('.lmm-alt__tabn');
        if (tn) tn.textContent = nKept;
      } else {
        b.hidden = !groupsLeft[k];
      }
    });
    /* Bleibt nur eine Gruppe uebrig, entfallen die Reiter ganz - wie beim Laden mit nur einer Gruppe. */
    var tabsWrap = root.querySelector('.lmm-altdrawer__tools [data-lmm-alt-tabs]');
    if (tabsWrap && t === 'all') tabsWrap.hidden = Object.keys(groupsLeft).length < 2;
    var restore = root.querySelector('[data-lmm-cmp-restore]');
    if (restore) {
      var nRm = heads.length - nKept;
      restore.hidden = nRm === 0;
      restore.textContent = nRm === 1
        ? '1 ausgeblendeten Artikel wieder zeigen'
        : nRm + ' ausgeblendete Artikel wieder zeigen';
    }
    /* Schalter "Nur Unterschiede" nur zeigen, wenn es gleiche Zeilen zum Ausblenden gibt.
       Im aktiven Zustand steht oben links in der Tabelle, wie viele ausgeblendet sind
       (sichtbare Rueckmeldung, ohne dass der Schalter breiter wird - Runde 4). */
    var diffBtn = root.querySelector('[data-lmm-cmp-diff]');
    if (diffBtn) {
      if (sameRows === 0) {
        diffBtn.hidden = true;
        diffBtn.setAttribute('aria-pressed', 'false');
      } else {
        diffBtn.hidden = false;
      }
    }
    var info = root.querySelector('[data-lmm-cmp-diffinfo]');
    if (info) {
      var infoTxt = (onlyDiff && sameRows > 0)
        ? sameRows + (sameRows === 1 ? ' gleiche Zeile' : ' gleiche Zeilen') + ' ausgeblendet'
        : '';
      info.textContent = infoTxt;
      info.hidden = infoTxt === '';
    }
  }

  /* ---------- Drawer oeffnen/schliessen ---------- */
  function openDrawer(opener, key) {
    var root = drawerRoot(key);
    if (!root) return;
    openerEl = opener || null;
    activeDrawer = root;
    /* Jedes Oeffnen startet frisch (Chris 02.10.2026): Reiter "Alle", "Nur Unterschiede" aus.
       Sonst merkt sich der Vergleich den Reiter vom letzten Mal und zeigt z. B. nur
       "Konventionell", obwohl der Kunde "Alle 5 Alternativen" geklickt hat. */
    root.querySelectorAll('.lmm-altdrawer__tools [data-lmm-alt-tab]').forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-lmm-alt-tab') === 'all' ? 'true' : 'false');
    });
    var diffReset = root.querySelector('[data-lmm-cmp-diff]');
    if (diffReset) diffReset.setAttribute('aria-pressed', 'false');
    /* Per X ausgeblendete Artikel sind beim naechsten Oeffnen wieder da. */
    root.querySelectorAll('.lmm-cmp .is-rm').forEach(function (c) { c.classList.remove('is-rm'); });
    var wrapReset = root.querySelector('.lmm-cmp-wrap');
    if (wrapReset) { wrapReset.scrollLeft = 0; wrapReset.scrollTop = 0; }
    applyDrawerFilters(root);
    root.hidden = false;
    /* Reflow erzwingen, damit die Slide-in-Transition greift. */
    void root.offsetWidth;
    root.classList.add('is-open');
    document.documentElement.classList.add('lmm-altdrawer-lock');
    var panel = root.querySelector('.lmm-altdrawer__panel');
    if (panel) panel.focus({ preventScroll: true });
  }

  function closeDrawer() {
    var root = activeDrawer || drawerRoot('');
    if (!root || root.hidden) return;
    root.classList.remove('is-open');
    document.documentElement.classList.remove('lmm-altdrawer-lock');
    window.setTimeout(function () { root.hidden = true; }, 280);
    if (openerEl && document.contains(openerEl)) openerEl.focus({ preventScroll: true });
    openerEl = null;
    activeDrawer = null;
  }

  /* ---------- Delegierte Events ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;

    var tabBtn = t.closest('[data-lmm-alt-tab]');
    if (tabBtn) {
      var tabsWrap = tabBtn.closest('[data-lmm-alt-tabs]');
      if (!tabsWrap) return;
      var inDrawer = tabBtn.closest('[data-lmm-alt-drawer]');
      if (inDrawer) {
        tabsWrap.querySelectorAll('[data-lmm-alt-tab]').forEach(function (b) {
          b.setAttribute('aria-pressed', b === tabBtn ? 'true' : 'false');
        });
        applyDrawerFilters(inDrawer);
      } else {
        setPanelTab(tabsWrap, tabBtn.getAttribute('data-lmm-alt-tab'));
      }
      return;
    }

    var diffBtn = t.closest('[data-lmm-cmp-diff]');
    if (diffBtn) {
      diffBtn.setAttribute('aria-pressed', diffBtn.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
      applyDrawerFilters(diffBtn.closest('[data-lmm-alt-drawer]'));
      return;
    }

    /* X im Spaltenkopf: Artikel aus dem Vergleich nehmen (Chris 02.10.2026). Der Fokus
       springt auf das naechste X, damit Tastaturnutzer nicht am Seitenanfang landen. */
    var rmBtn = t.closest('[data-lmm-cmp-rm]');
    if (rmBtn) {
      var rmRoot = rmBtn.closest('[data-lmm-alt-drawer]');
      var rmTh = rmBtn.closest('th[data-col]');
      var rmTable = rmBtn.closest('[data-lmm-cmp]');
      if (!rmRoot || !rmTh || !rmTable) return;
      var rmAll = Array.prototype.slice.call(rmTable.querySelectorAll('[data-lmm-cmp-rm]'));
      var rmIdx = rmAll.indexOf(rmBtn);
      rmTable.querySelectorAll('[data-col="' + rmTh.getAttribute('data-col') + '"]').forEach(function (c) {
        c.classList.add('is-rm');
      });
      applyDrawerFilters(rmRoot);
      var rmNext = null;
      var rmUsable = function (b) { return !b.hidden && b.offsetParent !== null; };
      for (var ri = rmIdx + 1; ri < rmAll.length && !rmNext; ri++) { if (rmUsable(rmAll[ri])) rmNext = rmAll[ri]; }
      for (var rj = rmIdx - 1; rj >= 0 && !rmNext; rj--) { if (rmUsable(rmAll[rj])) rmNext = rmAll[rj]; }
      if (!rmNext) rmNext = rmRoot.querySelector('[data-lmm-cmp-restore]:not([hidden])');
      if (rmNext) rmNext.focus({ preventScroll: true });
      return;
    }

    var restoreBtn = t.closest('[data-lmm-cmp-restore]');
    if (restoreBtn) {
      var rsRoot = restoreBtn.closest('[data-lmm-alt-drawer]');
      if (!rsRoot) return;
      rsRoot.querySelectorAll('.lmm-cmp .is-rm').forEach(function (c) { c.classList.remove('is-rm'); });
      applyDrawerFilters(rsRoot);
      var rsFocus = rsRoot.querySelector('.lmm-altdrawer__tools [data-lmm-alt-tab][aria-pressed="true"]') || rsRoot.querySelector('.lmm-altdrawer__panel');
      if (rsFocus) rsFocus.focus({ preventScroll: true });
      return;
    }

    var chip = t.closest('[data-lmm-alt-filter]');
    if (chip) {
      chip.setAttribute('aria-pressed', chip.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
      applyDrawerFilters(chip.closest('[data-lmm-alt-drawer]'));
      return;
    }

    var moreBtn = t.closest('[data-lmm-alt-more]');
    if (moreBtn) {
      var moreRoot = moreBtn.closest('[data-lmm-alt-drawer]');
      if (moreRoot) {
        moreRoot.__lmmMoreExpanded = true;
        applyDrawerFilters(moreRoot);
      }
      return;
    }

    var openBtn = t.closest('[data-lmm-alt-open]');
    if (openBtn) {
      openDrawer(openBtn, openBtn.getAttribute('data-lmm-alt-open'));
      return;
    }

    var closeBtn = t.closest('[data-lmm-alt-close]');
    if (closeBtn) {
      closeDrawer();
    }
  });

  document.addEventListener('keydown', function (e) {
    var root = activeDrawer;
    if (!root || root.hidden) return;
    if (e.key === 'Escape') {
      closeDrawer();
      return;
    }
    /* Einfache Fokus-Falle im Dialog. */
    if (e.key === 'Tab') {
      var panel = root.querySelector('.lmm-altdrawer__panel');
      if (!panel) return;
      var focusables = panel.querySelectorAll('a[href], button:not([disabled])');
      var vis = [];
      focusables.forEach(function (el) {
        if (el.offsetParent !== null) vis.push(el);
      });
      if (!vis.length) return;
      var first = vis[0];
      var last = vis[vis.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  });
})();
